module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl + '?' + _vm.suffix,
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8748c28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityNewBookMonth11.vue
// module id = 329
// module chunks = 1